export default "__VITE_ASSET__BsPudVCr__"